export function homePathForRole(role) {
  switch (role) {
    case 'admin':
      return '/admin';
    case 'translator':
      return '/pro';
    case 'lawyer':
      return '/lawyer';
    case 'notary':
      return '/notary';
    default:
      return '/app';
  }
}

export function canAccessPath(role, pathname) {
  if (pathname.startsWith('/admin')) return role === 'admin';
  if (pathname.startsWith('/pro')) return role === 'translator' || role === 'admin';
  if (pathname.startsWith('/lawyer')) return role === 'lawyer' || role === 'admin';
  if (pathname.startsWith('/notary')) return role === 'notary' || role === 'admin';
  if (pathname.startsWith('/legal')) return role === 'lawyer' || role === 'notary' || role === 'admin';
  if (pathname.startsWith('/app')) return role === 'client' || role === 'admin';
  return true;
}
